import { render, staticRenderFns } from "./googleVerification.vue?vue&type=template&id=61488dd6&scoped=true&"
import script from "./googleVerification.vue?vue&type=script&lang=js&"
export * from "./googleVerification.vue?vue&type=script&lang=js&"
import style0 from "./googleVerification.vue?vue&type=style&index=0&id=61488dd6&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61488dd6",
  null
  
)

export default component.exports